import { ILoadSchoolAssessmentsPayload } from './../../actions/assessments-actions/school-assessments-actions';
import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { BackgroundJob } from '../../../shared/services/background-job/background-job.service';
import { ISchoolAssessment } from '../../../shared/typings/interfaces/school-assessment.interface';
import * as schoolAssessmentsActions from '../../actions/assessments-actions/school-assessments-actions';
import { ApiService } from './../../../shared/services/api-service/api-service';

@Injectable()
export class SchoolAssessmentsEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private backgroundJob: BackgroundJob,
    private injector: Injector,
  ) {}

  @Effect()
  loadSchoolAssessments$ = this.actions$.pipe(
    ofType(schoolAssessmentsActions.LOAD_SCHOOL_ASSESSMENTS),
    switchMap((action: { type: string; payload: ILoadSchoolAssessmentsPayload }) => {
      return this.apiService.getSchoolAssessments(action.payload).pipe(
        switchMap((response: { data: { SchoolAssessments: ISchoolAssessment[] } }) => {
          return [new schoolAssessmentsActions.LoadSchoolAssessmentsSuccess(response)];
        }),
        catchError(error => of(new schoolAssessmentsActions.LoadSchoolAssessmentsFail(error))),
      );
    }),
  );

  @Effect({ dispatch: false })
  createSchoolAssessment$ = this.actions$.pipe(
    ofType(schoolAssessmentsActions.BULK_CREATE_SCHOOL_ASSESSMENTS),
    switchMap((action: { type: string; payload: schoolAssessmentsActions.ICreateSchoolAssessmentPayload }) => {
      const backgroundJobSpinner = this.injector.get('BackgroundJobSpinner');
      return this.apiService.createSchoolAssessments(action.payload).pipe(
        switchMap((response: { data: { bulkCreateSchoolAssessment: { backgroundJobId: string } } }) => {
          const {
            data: {
              bulkCreateSchoolAssessment: { backgroundJobId },
            },
          } = response;
          const promise = (this.backgroundJob as any)(backgroundJobId).promise();
          backgroundJobSpinner.activateSpinner('Updating assessments...', promise, null);
          return of(promise);
        }),
        catchError(error => {
          return of(new schoolAssessmentsActions.BulkCreateSchoolAssessmentsFail(error));
        }),
      );
    }),
  );

  @Effect({ dispatch: false })
  updateSchoolAssessment$ = this.actions$.pipe(
    ofType(schoolAssessmentsActions.BULK_UPDATE_SCHOOL_ASSESSMENTS),
    switchMap((action: { type: string; payload: schoolAssessmentsActions.IBulkUpdateSchoolAssessmentsPayload }) => {
      const backgroundJobSpinner = this.injector.get('BackgroundJobSpinner');
      return this.apiService.patchSchoolAssessments(action.payload).pipe(
        switchMap((response: { data: { bulkUpdateSchoolAssessment: { backgroundJobId: string } } }) => {
          const {
            data: {
              bulkUpdateSchoolAssessment: { backgroundJobId },
            },
          } = response;
          const promise = (this.backgroundJob as any)(backgroundJobId).promise();
          backgroundJobSpinner.activateSpinner('Updating assessments...', promise, null);
          return of(promise);
        }),
        catchError(error => {
          return of(new schoolAssessmentsActions.BulkUpdateSchoolAssessmentsFail(error));
        }),
      );
    }),
  );
}
